import React from "react"
import qs from "qs"
import CSSModules from "react-css-modules"
import axiosAPI from "../utils/request"
import expose, { injectOneTrack } from "../utils/track"
import styles from "./Down.css"

const isWeiXin = require("../common/isWeiXin")
const isQq = require("../common/isQq")
const logo = require("../assets/logo.png")

/**
 * 扫描二维码的渠道
 */
const SCAN_TYPE = {
  // 苹果手机相机扫描
  IOS: 1,
  // 国内小米手机相机扫描
  MIUI: 2,
  // 海外安卓手机相机扫描
  GOOGLE: 3,
  // 微信/QQ/国内除小米外其他安卓手机扫描
  WECHAT: 4,
}

// 从 navigator 对象中解构出用户代理、浏览器语言设置、浏览器版本等设置
const { userAgent, language, appVersion } = navigator
// 判断浏览器语言设置是否以 zh 开头
const zh = language.toLowerCase().startsWith("zh")
const { search } = window.location
const isIos = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
const isAndroid =
  userAgent.indexOf("Android") > -1 || userAgent.indexOf("Adr") > -1
const inWechatOrQQ = isWeiXin.isWeiXin() || isQq.isQq()

// 新协议，需要传递所有参数
const schemesurl = `mijia://device/connect${search}`

const isAndroidurl = "https://app.market.xiaomi.com/applinking/YedJke8"
const isIosurl =
  "https://itunes.apple.com/cn/app/米家-精品商城-智能生活/id957323480?mt=8"
const weiqqurl = `https://a.app.qq.com/o/simple.jsp?pkgname=com.xiaomi.smarthome&android_schema=${encodeURIComponent(
  schemesurl
)}&ios_scheme=${encodeURIComponent(schemesurl)}`
const googleurl =
  "https://play.google.com/store/apps/details?id=com.xiaomi.smarthome"

// 初始值
let appStoreUrl = weiqqurl
let type = SCAN_TYPE.WECHAT

if (!inWechatOrQQ) {
  if (isAndroid) {
    if (zh) {
      if (appVersion.indexOf("Miui") > -1) {
        appStoreUrl = isAndroidurl
        type = SCAN_TYPE.MIUI
      }
    } else {
      appStoreUrl = googleurl
      type = SCAN_TYPE.GOOGLE
    }
  } else if (isIos) {
    appStoreUrl = isIosurl
    type = SCAN_TYPE.IOS
  }
}

const {
  model,
  p: pdid,
  type: qrType,
  f: eventType
} = qs.parse(window.location.search, { ignoreQueryPrefix: true })

@CSSModules(styles)
export default class Down extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      cuttentNav: "应用商店",
      currentUrl: appStoreUrl
    }
  }
  componentDidMount() {
    // 解决 iOS 端微信页面直接跳走导致打点失败的问题
    injectOneTrack(() => {
      expose(
        model,
        pdid,
        qrType ? Number(qrType) : qrType,
        type,
        eventType,
      )
      this.invoke()
    }, () => {
      this.invoke()
    })
    // 进入页面时候上报
    // 安卓还是ios 得平台判断
    if (isIos) {
      this.stateConfig(
        "ios",
        "h5_page",
        "ewg.fj5",
        "",
        zh ? 0 : 1
      )
    }
    if (isAndroid) {
      this.stateConfig(
        "android",
        "h5_page",
        "ewg.fj5",
        "",
        zh ? 0 : 1
      )
    }
  }
  // 统计的参数配置
  stateConfig = (platform, type, key, shop, oversea) => {
    const { search } = window.location
    const parms = {
      stat: [
        {
          type,
          key,
          value: {
            model_id: `${search.split("&")[0].split("=")[1]}`,
            system: platform,
            oversea
          }
        }
      ]
    }
    if (isWeiXin.isWeiXin()) {
      parms.stat[0].value.source = 1
    } else if (isQq.isQq()) {
      parms.stat[0].value.source = 2
    } else {
      parms.stat[0].value.source = 3
    }
    shop ? (parms.stat[0].value.shop = shop) : ""
    this.statPv(JSON.stringify(parms.stat), platform)
  }
  // 进入页面
  statPv = (stat, platform) => {
    const lastParms = {
      source: "web",
      stat,
      platform,
      sessionId: Math.random(0, 10)
    }
    return axiosAPI("postStateNum", qs.stringify(lastParms))
  }

  invoke = () => {
    // 微信或者QQ中打开应用宝页面
    if (inWechatOrQQ) {
      window.location.href = weiqqurl
    } else {
      const loadDateTime = new Date()
      window.setTimeout(() => {
        const timeOutDateTime = new Date()
        if (timeOutDateTime - loadDateTime < 5000) {
          //  这里做的是跳转到应用商店的打点操作
          this.statShop(type)
          window.location.href = appStoreUrl
        } else {
          window.close()
        }
      }, 3000)
      // 打开米家的打点操作
      this.statOpen()
      window.location.href = schemesurl
    }
  }

  statShop = shop => {
    const { userAgent } = navigator
    const isIos = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    const isAndroid =
      userAgent.indexOf("Android") > -1 || userAgent.indexOf("Adr") > -1
    console.log("shop值是：", shop)
    if (isIos) {
      this.stateConfig(
        "ios",
        "h5_click",
        "ewg.fj5.g7z.sjb",
        shop,
        zh ? 0 : 1
      )
    }
    if (isAndroid) {
      this.stateConfig(
        "android",
        "h5_click",
        "ewg.fj5.g7z.sjb",
        shop,
        zh ? 0 : 1
      )
    }
  }
  statOpen = () => {
    const { userAgent } = navigator
    const isIos = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    const isAndroid =
      userAgent.indexOf("Android") > -1 || userAgent.indexOf("Adr") > -1
    if (isIos) {
      this.stateConfig(
        "ios",
        "h5_click",
        "ewg.fj5.g7z.dh6",
        "",
        zh ? 0 : 1
      )
    }
    if (isAndroid) {
      this.stateConfig(
        "android",
        "h5_click",
        "ewg.fj5.g7z.dh6",
        "",
        zh ? 0 : 1
      )
    }
  }

  render() {
    const { cuttentNav, currentUrl } = this.state
    return (
      <div styleName="local-down">
        <div styleName="local-down-box">
          <div styleName="local-down-logo">
            <img src={logo} />
            <div>米家</div>
          </div>
          <div styleName="local-down-nav">
            米家App是你家里的智能硬件管理平台。通过米家App，你可以完成手机与智能硬件之间便捷快速的交互，并实现智能设备之间的互联互通。
          </div>
          <div>
            <a href={currentUrl} styleName="local-down-button">
              {cuttentNav}
            </a>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Down.js